module.exports = __webpack_public_path__ + "static/media/faqhome.947655c1.svg";